import type {
  IUserApplyUserDefaultContactBody,
  IUserApplyUserDefaultContactRequest,
  IUserApplyUserDefaultContactResponse,
} from '@/app-package';

import axios from 'axios';

const applyUserDefaultContact = async (
  params: IUserApplyUserDefaultContactBody,
) => {
  const config: IUserApplyUserDefaultContactRequest = {
    url: `user/default/apply/${params.userId}/${params.contactId}`,
    method: 'post',
    data: params,
  };

  const { data } =
    await axios.request<IUserApplyUserDefaultContactResponse>(config);

  return data;
};

export default applyUserDefaultContact;
